import moment from "moment";

function workoutProgramMeta(workout) {
  const length = parseInt(workout?.programLength, 10);
  if (!Number.isFinite(length) || length <= 1) return null;
  const week = parseInt(workout?.currentWeek, 10);
  const currentWeek = Number.isFinite(week) && week > 0 ? week : 1;
  return { currentWeek, programLength: length };
}

function workoutsInWeek(workouts, weekContainingMoment) {
  const ws = weekContainingMoment.clone().startOf("week");
  const we = weekContainingMoment.clone().endOf("week");
  return (workouts || []).filter((w) => {
    const d = moment.unix(w.date);
    return d.isBetween(ws, we, "day", "[]");
  });
}

function programStatusFromWorkoutSubset(workouts) {
  const metas = (workouts || []).map(workoutProgramMeta).filter(Boolean);
  if (metas.length === 0) return null;

  const maxCurrentWeek = Math.max(...metas.map((m) => m.currentWeek));
  const atMax = metas.filter((m) => m.currentWeek === maxCurrentWeek);
  const programLength = Math.max(...atMax.map((m) => m.programLength));
  const weeksRemaining = Math.max(0, programLength - maxCurrentWeek);

  return {
    currentWeek: maxCurrentWeek,
    programLength,
    weeksRemaining,
  };
}

/**
 * Program progress: workouts in the calendar week containing
 * `referenceMoment` (highest currentWeek). If none, use the previous week only.
 */
export function clientProgramStatusFromWorkouts(
  workouts,
  referenceMoment = moment()
) {
  const ref = moment.isMoment(referenceMoment)
    ? referenceMoment
    : moment(referenceMoment);

  const thisWeekWorkouts = workoutsInWeek(workouts, ref);
  if (thisWeekWorkouts.length > 0) {
    return programStatusFromWorkoutSubset(thisWeekWorkouts);
  }

  const prevWeekWorkouts = workoutsInWeek(
    workouts,
    ref.clone().subtract(1, "week")
  );
  return programStatusFromWorkoutSubset(prevWeekWorkouts);
}

/** MUI palette path for program urgency text color. */
export function programUrgencyColor(weeksRemaining) {
  if (weeksRemaining == null) return "text.secondary";
  if (weeksRemaining <= 1) return "error.main";
  if (weeksRemaining < 4) return "warning.main";
  return "success.main";
}

export function programUrgencyLabel(weeksRemaining) {
  if (weeksRemaining == null) return "No program";
  if (weeksRemaining === 0) return "Program complete";
  if (weeksRemaining === 1) return "1 week left";
  return `${weeksRemaining} weeks left`;
}
